import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import Logo from '../assets/images/sovo-logo.svg';

const functions = getFunctions(undefined, 'europe-central2');
const requestPasswordReset = httpsCallable(functions, 'requestPasswordReset');

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await requestPasswordReset({ email });
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Wystąpił błąd podczas wysyłania emaila');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <div className="flex justify-center mb-4">
            <img src={Logo} alt="SOVO Logo" className="h-12 w-auto" />
          </div>

          <div className="flex items-center justify-center gap-1.5 mb-8">
            <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
            </svg>
            <span className="text-sm text-gray-400">SOVO Pay</span>
          </div>

          {success ? (
            <div className="text-center space-y-4">
              <div className="mx-auto w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="font-semibold text-lg text-gray-900">Email wysłany!</h3>
              <p className="text-sm text-gray-600">
                Sprawdź swoją skrzynkę. Wysłaliśmy link do resetowania hasła na adres <strong>{email}</strong>.
              </p>
              <p className="text-xs text-gray-500">
                Link jest ważny przez 60 minut. Jeśli nie widzisz emaila, sprawdź folder spam.
              </p>
              <Link
                to="/login"
                className="inline-block w-full h-10 leading-10 px-4 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                ← Wróć do logowania
              </Link>
            </div>
          ) : (
            <>
              <h3 className="font-semibold text-lg text-gray-900 text-center mb-2">Resetuj hasło</h3>
              <p className="text-sm text-gray-600 text-center mb-6">
                Podaj swój adres email, a wyślemy Ci link do resetowania hasła.
              </p>

              {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <p className="text-sm text-red-600">{error}</p>
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    id="email"
                    type="email"
                    placeholder="twoj@email.pl"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                    className="w-full h-10 px-3 py-2 border border-gray-300 rounded-md text-sm shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[var(--maroon)] focus:border-[var(--maroon)] disabled:opacity-50"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full h-10 px-4 py-2 bg-[var(--maroon)] text-white text-sm font-medium rounded-md hover:bg-[#5a0000] focus:outline-none focus:ring-2 focus:ring-[var(--maroon)] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {loading ? 'Wysyłanie...' : 'Wyślij link resetujący'}
                </button>

                <div className="text-center">
                  <Link to="/login" className="text-sm text-gray-600 hover:text-[var(--maroon)]">
                    ← Wróć do logowania
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
